<template>
  <div id="app">
    <init-i18n v-if="needInitI18n" />
    <router-view v-else></router-view>
    <portal-target name="vue-body-dialog"></portal-target>
  </div>
</template>

<script>
import InitI18n from '@/pages/initI18n.vue'
import { EventBus } from '@didi/events'
import { mapGetters } from 'vuex'
import { loading, jumper, toast } from '@/mixins/index.js'
import { trackEvent } from '@/common/utils/log.js'
import './formily-i18n.js'
import AndroidBackPressHandler from '@/common/utils/AndroidBackPressHandler.js'
import { PortalTarget } from 'portal-vue'

export default {
  name: 'App',
  components: {
    InitI18n,
    PortalTarget,
  },
  mixins: [loading, jumper, toast],
  data() {
    return {
      observer: null,
    }
  },
  computed: {
    ...mapGetters(['needInitI18n']),
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  created() {
    this.initKeyBorad()
    // 去掉灰度白名单
    // this.getInWhiteList()
    EventBus.on('ajaxErrorToast', this.createToast)
  },
  mounted() {
    const now = new Date().getTime()
    trackEvent('sailing_gattarman_x_homepage_loadedEnd', {
      time: now - window.performance.timing.navigationStart,
    })
    const staticResource = []
    try {
      if (window.performance && window.performance.getEntries) {
        // 长任务监控上报
        this.observer = new PerformanceObserver(list => {
          list.getEntries().forEach(entry => {
            try {
              const longDurationTime = Math.round(entry.duration)
              if (longDurationTime > 500) {
                trackEvent('tech_food_bdapp_performance_longtask', {
                  startTime: entry.startTime,
                  durationTime: longDurationTime,
                })
              }
            } catch (error) {
              console.error('Error handling performance observer:', error)
            }
          })
        })
        this.observer.observe({ type: 'longtask', buffered: true })

        window.performance.getEntries().forEach(item => {
          if (/(.js|.css|.ttf)/.test(item.name) || item.entryType === 'navigation') {
            staticResource.push({
              name: item.name,
              diff: item.responseEnd - item.requestStart,
            })
          }
        })
        trackEvent('sailing_gattarman_x_static_resource_load_timing', {
          staticResource,
          time: now,
        })
      }
    } catch (error) {
      console.error(error)
    }
    const nLoading = document.querySelector('#first-screen-loading')
    nLoading.style.display = 'none'
  },
  methods: {
    // 去掉灰度白名单
    // ...mapActions(['getInWhiteList']),
    createToast(txt) {
      const toast = this.$createToast(
        {
          time: 3000,
          type: 'error',
          txt,
        },
        false,
      )
      toast.show()
    },
    initKeyBorad() {
      let timer = null
      let canExitApp = false

      AndroidBackPressHandler.addListener(async () => {
        if (this.$route.path.indexOf('v2/home') > -1) {
          if (canExitApp) {
            if (window.Soda.exitApp) window.Soda.exitApp()
            return
          }
          const toast = this.$createToast({
            txt: this.$t('Gattaran_optimization__HjAa' /** 再次返回退出Explorer */),
            time: 3000,
            type: 'txt',
          })
          toast.show()
          canExitApp = true
          timer = setTimeout(() => {
            canExitApp = false
            this.initKeyBorad()
            clearTimeout(timer)
            timer = null
          }, 3000)
        } else {
          this.$router.back()
        }
      })
    },
  },
}
</script>

<style lang="scss">
#app {
  position: relative;
  height: 100%;
  background-color: $color-white;
}
.rich-dialog-icon + .rich-dialog-title .rich-dialog-title-def {
  white-space: pre-wrap;
}
.rich-toast-tip {
  max-height: unset;
}
.rich-popup-mask {
  background: #000;
  opacity: 0.5;
}
@media only screen and (min-width: 800px) {
  #app {
    width: 600px;
    margin: 0 auto;
    box-shadow: 0px 0px 10px #f4f4f4;
  }
  body {
    background: #fafafa;
  }
  // .rich-popup {
  //   width: 600px;
  //   left: 0;
  //   right: 0;
  //   margin: 0 auto;
  // }
  .rich-toast-tip {
    max-height: unset;
  }
}
</style>
